import { createFileRoute } from "@tanstack/react-router";

import { getUserHeadMeta } from "@/helpers/user-meta";
import { fetchReviews } from "@/loaders/user-reviews";
import Reviews from "@/pages/user/reviews";

export const Route = createFileRoute("/@{$username}/reviews/review/$reviewId")({
  component: ReviewDetailPage,
  head: ({ loaderData }) => {
    if (!loaderData) {
      return {};
    }
    return {
      meta: [
        ...getUserHeadMeta(loaderData.user, "reviews"),
        { content: "noindex", name: "robots" },
      ],
    };
  },
  loader: ({ params }) =>
    fetchReviews({
      data: {
        reviewId: params.reviewId,
        username: params.username,
      },
    }),
});

function ReviewDetailPage() {
  const data = Route.useLoaderData();
  if (!data) {
    return null;
  }
  return <Reviews {...data} />;
}
